export default __webpack_public_path__ + "c141381259dfa9ced7553423fbc87973.jpg";